import {
  GET_CURRENT_PERSON_ALL_STATUS_REQUEST,
  GET_CURRENT_PERSON_ALL_STATUS_SUCCESS,
  GET_CURRENT_PERSON_ALL_STATUS_FAILURE,
  GET_DAY_BEFORE_COUNT_BY_STATUS_REQUEST,
  GET_DAY_BEFORE_COUNT_BY_STATUS_SUCCESS,
  GET_DAY_BEFORE_COUNT_BY_STATUS_FAILURE,
  GET_CURRENT_PERSON_STATUS_REQUEST,
  GET_CURRENT_PERSON_STATUS_SUCCESS,
  GET_CURRENT_PERSON_STATUS_FAILURE,
  GET_PERSON_LEAD_NOTE_STATUS_REQUEST,
  GET_PERSON_LEAD_NOTE_STATUS_SUCCESS,
  GET_PERSON_LEAD_NOTE_STATUS_FAILURE,
  GET_PERSON_QR_CODE_STATUS_REQUEST,
  GET_PERSON_QR_CODE_STATUS_SUCCESS,
  GET_PERSON_QR_CODE_STATUS_FAILURE,
} from '../../constants/ActionTypes'

import { CurrentPersonStatusApi } from '../api/CurrentPersonStatusApi';
import { TimelineLabelType } from '../../constants/ComponentTypes';

// アプローチに含めるものが多数あるので、まとめる
const requestTimelineStatusLabelTypes = {
  APPROACH: {
    value: TimelineLabelType.APPROACH.value, combination: [
      TimelineLabelType.APPROACH.value,
      TimelineLabelType.PROOFREAD_CREATED.value,
      TimelineLabelType.ORDER_SHIPPED.value,
      TimelineLabelType.ORDER_PRINTING.value,
    ]
  },
  APPOINTMENT: { value: TimelineLabelType.APPOINTMENT.value, combination: [TimelineLabelType.APPOINTMENT.value] },
  APPROACH_NG: { value: TimelineLabelType.APPROACH_NG.value, combination: [TimelineLabelType.APPROACH_NG.value] },
  CLOSE: { value: TimelineLabelType.CLOSE.value, combination: [TimelineLabelType.CLOSE.value] },
  NON_CONNECT: { value: TimelineLabelType.NON_CONNECT.value, combination: [TimelineLabelType.NON_CONNECT.value] },
  DECLINED: { value: TimelineLabelType.DECLINED.value, combination: [TimelineLabelType.DECLINED.value] },
  CONNECT: { value: TimelineLabelType.CONNECT.value, combination: [TimelineLabelType.CONNECT.value] },
  SENT_DOCUMENT: { value: TimelineLabelType.SENT_DOCUMENT.value, combination: [TimelineLabelType.SENT_DOCUMENT.value] },
}

/*** GET /current_person_status ***/
const getCurrentPersonAllStatusRequest = (type) => ({
  type: GET_CURRENT_PERSON_ALL_STATUS_REQUEST,
  payload: {
    type: type
  }
});

const getCurrentPersonAllStatusSuccess = (type, data, pageInfo) => ({
  type: GET_CURRENT_PERSON_ALL_STATUS_SUCCESS,
  payload: {
    type: type,
    data: data,
    pageInfo: pageInfo,
  }
});

const getCurrentPersonAllStatusFailure = (type, error) => ({
  type: GET_CURRENT_PERSON_ALL_STATUS_FAILURE,
  payload: {
    type: type,
    error: error
  }
});

export function getCurrentPersonAllStatus(data = {}) {
  return async (dispatch) => {

    let query = {
      'paging': 1,
      'page': 1,
      'per_page': 5,
      'include_day_before_count': true,
      ...data,
    }

    // 先に全てのステータスをリクエストしておくことで、全てのLoadingフラグを立てる
    Object.values(requestTimelineStatusLabelTypes).forEach((item) => {
      dispatch(getCurrentPersonAllStatusRequest(item.value));
    });

    // 初期化後にAPI実行
    Object.values(requestTimelineStatusLabelTypes).forEach((item) => {
      // アドレス表示があれば選択したステータスの場合with_address_dataを1にする
      const selectedQuery = {};
      if (query.hasOwnProperty("selected_status") && item.value === query["selected_status"]) {
        selectedQuery["with_address_data"] = 1;
      }

      CurrentPersonStatusApi.getCurrentPersonStatus({
        ...query,
        ...selectedQuery,
        'timeline_status': [...item.combination]
      }, dispatch)
        .then((response) => {
          dispatch(getCurrentPersonAllStatusSuccess(
            item.value,
            response.data.data,
            response.data.meta
          ));
        })
        .catch((error) => {
          dispatch(getCurrentPersonAllStatusFailure(item.value, error.response));
        });
    });
  };
}

/*** GET /current_person_status ***/
const getDayBeforeCountByStatusRequest = (type) => ({
  type: GET_DAY_BEFORE_COUNT_BY_STATUS_REQUEST,
  payload: {
    type: type
  }
});

const getDayBeforeCountByStatusSuccess = (type, data, pageInfo) => ({
  type: GET_DAY_BEFORE_COUNT_BY_STATUS_SUCCESS,
  payload: {
    type: type,
    data: data,
    pageInfo: pageInfo,
  }
});

const getDayBeforeCountByStatusFailure = (type, error) => ({
  type: GET_DAY_BEFORE_COUNT_BY_STATUS_FAILURE,
  payload: {
    type: type,
    error: error
  }
});

export function getDayBeforeCountByStatus(data = {}) {
  return async (dispatch) => {
    let query = {
      'include_day_before_count': true,
      ...data,
    }

    // 先に全てのステータスをリクエストしておくことで、全てのLoadingフラグを立てる
    Object.values(requestTimelineStatusLabelTypes).forEach((item) => {
      dispatch(getDayBeforeCountByStatusRequest(item.value));
    });

    // 初期化後にAPI実行
    Object.values(requestTimelineStatusLabelTypes).forEach((item) => {
      CurrentPersonStatusApi.getCurrentPersonStatus({
        ...query,
        'timeline_status': [...item.combination]
      }, dispatch)
        .then((response) => {
          dispatch(getDayBeforeCountByStatusSuccess(
            item.value,
            response.data.data,
            response.data.meta
          ));
        })
        .catch((error) => {
          dispatch(getDayBeforeCountByStatusFailure(item.value, error.response));
        });
    });
  };
}


/*** GET /current_person_status ***/
const getCurrentPersonStatusRequest = (type) => ({
  type: GET_CURRENT_PERSON_STATUS_REQUEST,
  payload: {
    type: type
  }
});

const getCurrentPersonStatusSuccess = (data, pageInfo) => ({
  type: GET_CURRENT_PERSON_STATUS_SUCCESS,
  payload: {
    data: data,
    pageInfo: pageInfo,
  }
});

const getCurrentPersonStatusFailure = (type, error) => ({
  type: GET_CURRENT_PERSON_STATUS_FAILURE,
  payload: {
    error: error
  }
});

/*** GET /current_person_status ***/
export function getCurrentPersonStatus(data = {}) {
  return async (dispatch) => {

    let query = {
      'paging': 1,
      'page': 1,
      'per_page': 5,
      'include_corporation_count': true,
      'include_day_before_count': true,
      ...data,
    }

    dispatch(getCurrentPersonStatusRequest());

    CurrentPersonStatusApi.getCurrentPersonStatus({
      ...query,
    }, dispatch)
      .then((response) => {
        dispatch(getCurrentPersonStatusSuccess(
          response.data.data,
          response.data.meta
        ));
      })
      .catch((error) => {
        dispatch(getCurrentPersonStatusFailure(error.response));
      });
  };
}

/*** GET /person_status ***/
const getPersonLeadNoteStatusRequest = () => ({
  type: GET_PERSON_LEAD_NOTE_STATUS_REQUEST
});

const getPersonLeadNoteStatusSuccess = (data, pageInfo) => ({
  type: GET_PERSON_LEAD_NOTE_STATUS_SUCCESS,
  payload: {
    data: data,
    pageInfo: pageInfo,
  }
});

const getPersonLeadNoteStatusFailure = (error) => ({
  type: GET_PERSON_LEAD_NOTE_STATUS_FAILURE,
  payload: {
    error: error
  }
});

export function getPersonLeadNoteStatus(data = {}) {
  return async (dispatch) => {

    let query = {
      'paging': 1,
      'page': 1,
      'per_page': 5,
      'has_lead_note': 1,
      'include_corporation_count': true,
      'include_day_before_count': true,
      ...data,
    }

    dispatch(getPersonLeadNoteStatusRequest());

    CurrentPersonStatusApi.getPersonStatus({
      ...query,
    }, dispatch)
      .then((response) => {
        dispatch(getPersonLeadNoteStatusSuccess(
          response.data.data,
          response.data.meta
        ));
      })
      .catch((error) => {
        dispatch(getPersonLeadNoteStatusFailure(error.response));
      });
  };
}

/*** GET /person_status ***/
const getPersonQrCodeStatusRequest = () => ({
  type: GET_PERSON_QR_CODE_STATUS_REQUEST
});

const getPersonQrCodeStatusSuccess = (data, pageInfo) => ({
  type: GET_PERSON_QR_CODE_STATUS_SUCCESS,
  payload: {
    data: data,
    pageInfo: pageInfo,
  }
});

const getPersonQrCodeStatusFailure = (error) => ({
  type: GET_PERSON_QR_CODE_STATUS_FAILURE,
  payload: {
    error: error
  }
});

export function getPersonQrCodeStatus(data = {}) {
  return async (dispatch) => {

    let query = {
      'paging': 1,
      'page': 1,
      'per_page': 5,
      'include_corporation_count': true,
      'include_day_before_count': true,
      ...data,
    }

    dispatch(getPersonQrCodeStatusRequest());

    CurrentPersonStatusApi.getPersonStatus({
      ...query, 'timeline_status': [TimelineLabelType.QR_CODE_REACTION.value],
    }, dispatch)
      .then((response) => {
        dispatch(getPersonQrCodeStatusSuccess(
          response.data.data,
          response.data.meta
        ));
      })
      .catch((error) => {
        dispatch(getPersonQrCodeStatusFailure(error.response));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/CurrentPersonStatus.js